/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import Header from "../../components/Header";
import Menu from "./Menu";
import Cart from "./cart/Cart";
import History from "../history/History";
import About from "../about/About";
import Sidebar from "../../components/Sidebar";
import ErrorBoundary from "../../ErrorBoundary"; // Import your ErrorBoundary component

export default function MenuPage({
  authToken,
  id,
  cartTotal,
  setCartTotal,
  restaurantDetail,
  restaurantMessage,
  currentSelected,
  setCurrentSelected,
  tableReservationCart,
  isDineIn,
  selectedType,
  setSelectedType,
  ssoUserDetails,
  ssoAddress,
  handleSSOAddress,
  open,
  setRestaurantDetail,
  isLanguageOpen,
  setIsTableReservation,
  menuCategories,
  setMenuCategories,
}) {
  const [isHeader, setIsHeader] = React.useState(true);
  const [selectedCategory, setSelectedCategory] = React.useState("");

  return (
    <div className="relative w-full max-w-5xl mx-auto flex">
      <ErrorBoundary>
        <Sidebar
          id={id}
          authToken={authToken}
          restaurantDetail={restaurantDetail}
          currentSelected={currentSelected}
          setCurrentSelected={setCurrentSelected}
          cartTotal={cartTotal}
          tableReservationCart={tableReservationCart}
          selectedType={selectedType}
          setSelectedType={setSelectedType}
        />
      </ErrorBoundary>
      <div className="w-full sm:w-[calc(100%-128px)]">
        <ErrorBoundary>
          <Header
            id={id}
            authToken={authToken}
            restaurantDetail={restaurantDetail}
            restaurantMessage={restaurantMessage}
            currentSelected={currentSelected}
            setCurrentSelected={setCurrentSelected}
            cartTotal={cartTotal}
            isHeader={isHeader}
            tableReservationCart={tableReservationCart}
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            open={open}
            isLanguageOpen={isLanguageOpen}
            menuCategories={menuCategories}
            setSelectedCategory={setSelectedCategory}
            selectedCategory={selectedCategory}
          />
        </ErrorBoundary>
        <div className="px-3 sm:px-6 py-4 sm:py-5">
          {currentSelected === "menu" && (
            <ErrorBoundary>
              <Menu
                authToken={authToken}
                id={id}
                setCartTotal={setCartTotal}
                restaurantDetail={restaurantDetail}
                isDineIn={isDineIn}
                selectedType={selectedType}
                setSelectedType={setSelectedType}
                setRestaurantDetail={setRestaurantDetail}
                setSelectedCategory={setSelectedCategory}
                selectedCategory={selectedCategory}
                setMenuCategories={setMenuCategories}
              />
            </ErrorBoundary>
          )}
          {currentSelected === "cart" && (
            <ErrorBoundary>
              <Cart
                authToken={authToken}
                id={id}
                setCartTotal={setCartTotal}
                restaurantDetail={restaurantDetail}
                setIsHeader={setIsHeader}
                currentSelected={currentSelected}
                setCurrentSelected={setCurrentSelected}
                isDineIn={isDineIn}
                selectedType={selectedType}
                setSelectedType={setSelectedType}
                ssoUserDetails={ssoUserDetails}
                ssoAddress={ssoAddress}
                handleSSOAddress={handleSSOAddress}
                setRestaurantDetail={setRestaurantDetail}
                setIsTableReservation={setIsTableReservation}
              />
            </ErrorBoundary>
          )}
          {currentSelected === "history" && (
            <ErrorBoundary>
              <History
                authToken={authToken}
                id={id}
                restaurantDetail={restaurantDetail}
                ssoUserDetails={ssoUserDetails}
                setCurrentSelected={setCurrentSelected}
                setCartTotal={setCartTotal}
              />
            </ErrorBoundary>
          )}
          {currentSelected === "about" && (
            <ErrorBoundary>
              <About
                authToken={authToken}
                restaurantDetail={restaurantDetail}
                id={id}
              />
            </ErrorBoundary>
          )}
        </div>
      </div>
    </div>
  );
}
